import { render, staticRenderFns } from "./Sporternaehrung.vue?vue&type=template&id=76466106&"
import script from "./Sporternaehrung.vue?vue&type=script&lang=js&"
export * from "./Sporternaehrung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports